export default "__VITE_ASSET__C_rZub9s__"